import React from 'react'
import { useState, useEffect } from 'react';
import Carousal from '../components/Carousal'
import { Marquee } from "@devnomic/marquee";
import "@devnomic/marquee/dist/index.css";


function Home() {
  const [notices, setNotices] = useState([]);
  const [links, setLinks] = useState([]);
  const [newsletters, setNewsletters] = useState([]);
  const [count, setCount] = useState(0);
  const [activities, setActivities] = useState([]);


  useEffect(() => {
    //var nf = new Intl.NumberFormat();
    const storedCount = localStorage.getItem("pageVisits");
    const initialCount = Number(storedCount) || 0;
    //const initialCount = 0;

    //nf.format(Math.floor(initialCount));

    //Math.floor
    setCount(initialCount + 0.5);
    localStorage.setItem("pageVisits", initialCount + 0.5);

  }, []);
  return (
    <div style={{
      minHeight: "100vh",
      backgroundColor: "#F5F5F5",
      justifyContent: "center",
      alignItems: "center",
    }}>
      <div>
        <div
          style={{
            width: "100%",
            height: "60vh",
          }}
          className="carousel-wrapper">
          <Carousal />

          <div className="row">
            <div className="col">
            </div>
          </div>

        </div>
        {/* start text */}
        <div style={{ background: "#F5F5F5", padding: "80px 0" }}>

          <div className="container">

            <div style={{ textAlign: "center", marginBottom: "60px" }}>
              <h2 style={{ fontSize: "36px", fontWeight: "600", color: "#0C2B4B" }}>
                Digital Management Platforms for Institutions & Communities
              </h2>

              <p
                style={{
                  fontSize: "18px",
                  marginTop: "20px",
                  lineHeight: "1.8",
                  color: "#555",
                  maxWidth: "870px",
                  margin: "20px auto"
                }}
              >
                We build structured digital platforms designed to simplify administration,
                automate financial workflows, and improve transparency. Our solutions
                support housing societies, commercial complexes, schools, and colleges.
              </p>
            </div>

            <div className="row text-center">

              <div className="col-md-3 mb-4">
                <div
                  style={{
                    background: "#ffffff",
                    padding: "30px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
                    height: "100%"
                  }}
                >
                  <h4 style={{ fontWeight: "600", marginBottom: "15px", color: "#0C2B4B" }}>
                    🎓 Schools & Colleges
                  </h4>
                  <p style={{ fontSize: "16px", color: "#666", lineHeight: "1.6" }}>
                    Streamline Student Records, Fee Collection, Attendance and
                    communication with parents through a structured system.
                  </p>

                </div>
              </div>

              <div className="col-md-3 mb-4">
                <div
                  style={{
                    background: "#ffffff",
                    padding: "30px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
                    height: "100%"
                  }}
                >
                  <h4 style={{ fontWeight: "600", marginBottom: "15px", color: "#0C2B4B" }}>
                    🏢 Housing Societies
                  </h4>
                  <p style={{ fontSize: "16px", color: "#666", lineHeight: "1.6" }}>
                    Manage maintenance billing, complaints, notices and resident records
                    through an integrated web portal and mobile app.
                  </p>

                </div>
              </div>

              <div className="col-md-3 mb-4">
                <div
                  style={{
                    background: "#ffffff",
                    padding: "30px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
                    height: "100%"
                  }}
                >
                  <h4 style={{ fontWeight: "600", marginBottom: "15px", color: "#0C2B4B" }}>
                    🏬 Commercial Complexes
                  </h4>
                  <p style={{ fontSize: "16px", color: "#666", lineHeight: "1.6" }}>
                    Efficiently manage tenant records, billing, maintenance tracking
                    and operational reports.
                  </p>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <div
                  style={{
                    background: "#ffffff",
                    padding: "30px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
                    height: "100%"
                  }}
                >
                  <h4 style={{ fontWeight: "600", marginBottom: "15px", color: "#0C2B4B" }}>
                    📊 Reporting & Transparency
                  </h4>
                  <p style={{ fontSize: "16px", color: "#666", lineHeight: "1.6" }}>
                    Access centralized dashboards and reports that provide complete
                    visibility into finances and operations.
                  </p>
                </div>
              </div>

            </div>

          </div>

        </div>
        {/* end text */}
      </div>

    </div>
  )
}

export default Home
